import React from "react";
import fallbackImage from "../../../../../../../assets/fallback_images/collectionSt.webp";
import { BinIcon } from "../../../../../../Icons/BinIcon";
import CertificateIcon from "../../../../../../Icons/CertificateIcon";
import { LazyImg } from "../../../../../../LazyImg";
import s from "./CartItem.module.scss";

type Props = {
  address: string;
  title: string;
  collectionTitle: string;
  price?: string | null;
  ticker?: string;
  image?: string;
  removeHandler: (address: string) => void;
};

export const CartItem: React.FC<Props> = ({
  address,
  title,
  collectionTitle,
  price,
  ticker,
  image,
  removeHandler,
}) => {
  return (
    <div className={s.wrapper}>
      <div className={s.image_wrapper}>
        <LazyImg imgUrl={image} alt={title} fallbackImgURL={fallbackImage} />
      </div>
      <div className={s.info_wrapper}>
        <span className={s.info_title}>{title}</span>
        {!!collectionTitle && (
          <p className={s.info_collection}>
            {collectionTitle} <CertificateIcon />
          </p>
        )}
        <p className={s.info_price}>
          {price} {ticker}
        </p>
      </div>
      <div className={s.bin_wrapper} onClick={() => removeHandler(address)}>
        <BinIcon />
      </div>
    </div>
  );
};

export default CartItem;
